import { exec } from '../utils';
import type {
  BadgeCredentials,
  BadgeAuthenticationArgs,
  BadgeAuthenticationExecVariables,
  BadgeAuthenticationExecResponse
} from '@src/types';

/**
 * Initiates the badge authentication flow.
 * Additional authentication methods will be supported in the future.
 */
export const badgeAuthentication = async ({ username }: BadgeAuthenticationArgs): Promise<BadgeCredentials> => {
  const query = `
    mutation badgeAuthentication(
      $username: String!
    ) {
      authenticate(username: $username) {
        oneTimeToken
        uuid
        name
        email
      }
    }
  `;

  const data = await exec<BadgeAuthenticationExecVariables, BadgeAuthenticationExecResponse>(
    query, {
      variables: {
        username,
      },
    },
  );

  return data.authenticate;
};
